import { Routes } from '@angular/router';
import { LoginComponent } from './core/auth/login/login.component';
import { ArchiveComponent } from './features/archive/archive.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { authGuard } from './core/auth/auth.guard';
import { DailyArchiveComponent } from './features/daily-archive/daily-archive.component';
import { MonthlyStatsComponent } from './features/monthly-stats/monthly-stats.component';
import { DailyStatsComponent } from './features/daily-stats/daily-stats.component';
import { KeywordsComponent } from './features/keywords/keywords.component';
import { SendAsClientComponent } from './features/send-as-client/send-as-client.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: 'archive',
    component: ArchiveComponent,
    canActivate: [authGuard],
  },
  {
    path: 'daily-archive',
    component: DailyArchiveComponent,
    canActivate: [authGuard],
  },
  {
    path: 'monthly-stats',
    component: MonthlyStatsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'daily-stats',
    component: DailyStatsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'keywords',
    component: KeywordsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'send-as-client',
    component: SendAsClientComponent,
    canActivate: [authGuard],
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];
